import { render, staticRenderFns } from "./PromptDiffViewer.vue?vue&type=template&id=024ecea6&scoped=true"
import script from "./PromptDiffViewer.vue?vue&type=script&lang=js"
export * from "./PromptDiffViewer.vue?vue&type=script&lang=js"
import style0 from "./PromptDiffViewer.vue?vue&type=style&index=0&id=024ecea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ecea6",
  null
  
)

export default component.exports